import PreferenceApi from '../api-services/PreferenceApi';

import CoreUtils from '../common/utils/CoreUtils';

export default class PreferenceManager {
  static CurrentMonth         = 'CurrentMonth';
  static ColumnFiltering      = 'ColumnFiltering';
  static ColumnGrouping       = 'ColumnGrouping';
  static ColumnSorting        = 'ColumnSorting';
  static ColumnSizing         = 'ColumnSizing';
  static ColumnVisibility     = 'ColumnVisibility';
  static ShowPastDays         = 'ShowPastDays';
  static UseSelectionEditMode = 'UseSelectionEditMode';
  static ShowHourUnits        = 'ShowHourUnits';
  static DateViewMode         = 'DateViewMode';
  static isNotifyEnabled      = 'isNotifyEnabled';
  static Configuration        = 'Configuration';
  static SelectedCounterparty = 'SelectedCounterparty';
  static SelectedContract     = 'SelectedContract';

  static preferences = {};

  static clearUserPreferences() {
    PreferenceManager.preferences = {};
  }

  static async loadUserPreferences() {
    var preferenceDtos = await PreferenceApi.retrieveAllPreferences();

    PreferenceManager.preferences = {};

    preferenceDtos.forEach(
      preferenceDto => PreferenceManager.updateValueInternal(
        preferenceDto.group,
        preferenceDto.name,
        preferenceDto.value
      ));
  }

  static retrieveDate(group, name, defaultDate) {
    var value = PreferenceManager.retrieveValue(group, name, undefined);
    return !CoreUtils.isUndefinedOrNull(value)
      ? new Date(value)
      : defaultDate;
  }

  static updateDate(group, name, date) {
    PreferenceManager.updateValue(
      group,
      name,
      !CoreUtils.isUndefinedOrNull(date)
        ? date.toJSON()
        : ''
    );
  }

  static retrieveValue(group, name, defaultValue) {
    var groupValues = PreferenceManager.preferences[group];
    if (groupValues === undefined)
      return defaultValue;

    var value = groupValues[name];

    return value !== undefined
      ? value
      : defaultValue;
  }

  static updateValue(group, name, value) {
    PreferenceManager.updateValues([{
      group: group,
      name: name,
      value: value
    }]);
  }

  static updateValues(preferences) {
    if (CoreUtils.isUndefinedOrNull(preferences) || !(preferences instanceof Array))
      return;

    preferences.forEach(preference => {
      PreferenceManager.updateValueInternal(
        preference.group,
        preference.name,
        preference.value
      );
    });

    PreferenceApi.updatePreferences(preferences);
  }

  static updateValueInternal(group, name, value) {
    var groupValues = PreferenceManager.preferences[group];
    if (groupValues === undefined) {
      groupValues = {};
      PreferenceManager.preferences[group] = groupValues;
    }

    groupValues[name] = value;
  }
}
